// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14oBb","label":"styles_label__cJ3HG"};